(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-sell-to-us-editorial"] && !Shopify.designMode) return;
  try {
    
if (!(window.Shopify && window.Shopify.designMode)) {
(function (make) {
  "use strict";
  const api = make();
  if (typeof module === "object" && module.exports) {
    module.exports = api;
  } else if (typeof window !== "undefined") {
    api.install(window);
  }
})(function () {
  "use strict";

  const FORM_ID = "787234";
  const PAGE_PATH = "/pages/sell-to-us";
  const EVENT_NAME = "rbs_seller_form_success";
  const DESTINATION = "G-HFPNFY3GD7";
  const INSTALL_KEY = "__rbsSellerFormSuccessV1";
  const CONTAINER = '[data-forms-id="forms-root-787234"]';
  const FORM = 'form[data-testid="form"]';
  const MAX_PENDING_MS = 30 * 60 * 1000;

  function isTargetPage(pathname) {
    return pathname === PAGE_PATH || pathname === PAGE_PATH + "/";
  }

  function privacyAllowed(win) {
    try {
      const privacy = win.Shopify && win.Shopify.customerPrivacy;
      return Boolean(
        privacy &&
        typeof privacy.analyticsProcessingAllowed === "function" &&
        typeof privacy.marketingAllowed === "function" &&
        typeof privacy.saleOfDataAllowed === "function" &&
        privacy.analyticsProcessingAllowed() === true &&
        privacy.marketingAllowed() === true &&
        privacy.saleOfDataAllowed() === true
      );
    } catch (_) {
      return false;
    }
  }

  function sendExistingTag(win) {
    if (!privacyAllowed(win) || typeof win.gtag !== "function") return false;
    try {
      win.gtag("event", EVENT_NAME, {
        send_to: DESTINATION,
        form_id: FORM_ID,
        event_source: "shopify_forms_success_state"
      });
      return true;
    } catch (_) {
      return false;
    }
  }

  function createController(options) {
    const now = options.now || Date.now;
    const isAllowed = options.isAllowed || function () { return false; };
    const send = options.send || function () { return false; };
    const maxPendingMs = options.maxPendingMs || MAX_PENDING_MS;
    let step = null;
    let pending = null;
    let sequence = 0;

    function permitted() {
      try {
        return isAllowed() === true;
      } catch (_) {
        return false;
      }
    }

    function cancel() {
      pending = null;
    }

    function arm(attempt) {
      if (
        step !== "form" ||
        attempt.formId !== FORM_ID ||
        attempt.trusted !== true ||
        attempt.visible !== true ||
        !permitted()
      ) return false;
      pending = { nonce: ++sequence, startedAt: now() };
      return true;
    }

    function observe(nextStep, connected) {
      const prior = step;
      step = nextStep;
      if (connected !== true || (nextStep !== "form" && nextStep !== "success")) {
        cancel();
        return false;
      }
      if (nextStep !== "success" || prior !== "form" || !pending) return false;
      const attempt = pending;
      cancel();
      const age = now() - attempt.startedAt;
      if (age < 0 || age > maxPendingMs || !permitted()) return false;
      try {
        return send() === true;
      } catch (_) {
        return false;
      }
    }

    return Object.freeze({ arm: arm, observe: observe, cancel: cancel });
  }

  function install(win) {
    const doc = win.document;
    if (!doc || !win.location || !isTargetPage(win.location.pathname)) return null;
    if (win[INSTALL_KEY]) return win[INSTALL_KEY];
    if (typeof win.MutationObserver !== "function") return null;

    let running = false;
    let destroyed = false;
    let binding = null;

    function ancestry(node) {
      const nodes = new Set();
      while (node) {
        nodes.add(node);
        node = node.parentNode;
      }
      return nodes;
    }

    function removedSince(records, nodes) {
      if (!Array.isArray(records)) return false;
      return records.some(function (record) {
        return Array.from(record.removedNodes || []).some(function (node) {
          return nodes.has(node);
        });
      });
    }

    function releaseBinding() {
      if (!binding) return;
      binding.controller.cancel();
      binding.observer.disconnect();
      binding.root.removeEventListener("submit", binding.onSubmit, true);
      binding = null;
    }

    function attach(records) {
      if (!running || !isTargetPage(win.location.pathname)) {
        releaseBinding();
        return;
      }
      if (binding && removedSince(records, binding.ancestors)) releaseBinding();
      const containers = doc.querySelectorAll(CONTAINER);
      const outer = containers.length === 1 ? containers[0] : null;
      const hosts = outer ? outer.querySelectorAll("shopify-forms-embed") : [];
      const host = hosts.length === 1 ? hosts[0] : null;
      const root = host && host.shadowRoot;
      if (binding && binding.root === root && host.isConnected) return;
      releaseBinding();
      if (!root || !host.isConnected) return;

      const controller = createController({
        now: function () { return win.performance.now(); },
        isAllowed: function () {
          return privacyAllowed(win) && typeof win.gtag === "function";
        },
        send: function () { return sendExistingTag(win); }
      });
      let currentApp = null;
      let appAncestors = new Set();

      function sample(records) {
        const app = root.querySelector("#app-embed[data-current-step]");
        if (currentApp && (app !== currentApp || removedSince(records, appAncestors))) {
          controller.cancel();
        }
        currentApp = app;
        appAncestors = ancestry(app);
        const connected = running && host.isConnected &&
          isTargetPage(win.location.pathname);
        return controller.observe(
          app ? app.getAttribute("data-current-step") : null,
          connected
        );
      }

      function onSubmit(event) {
        const form = event.target;
        if (!form || !form.matches || !form.matches(FORM) || !root.contains(form)) return;
        sample();
        let visible = false;
        try {
          const style = win.getComputedStyle(form);
          visible = running && host.isConnected && form.isConnected &&
            doc.visibilityState === "visible" && !form.hidden &&
            form.getClientRects().length > 0 &&
            style.display !== "none" && style.visibility !== "hidden" &&
            style.visibility !== "collapse";
        } catch (_) {
          visible = false;
        }
        controller.arm({ formId: FORM_ID, trusted: event.isTrusted, visible: visible });
      }

      const observer = new win.MutationObserver(sample);
      binding = { root: root, host: host, ancestors: ancestry(host), observer: observer,
        controller: controller, onSubmit: onSubmit };
      root.addEventListener("submit", onSubmit, true);
      observer.observe(root, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["data-current-step"]
      });
      sample();
    }

    const discovery = new win.MutationObserver(attach);

    function pause() {
      running = false;
      discovery.disconnect();
      releaseBinding();
    }

    function start() {
      if (destroyed || running) return;
      running = true;
      if (doc.documentElement) {
        discovery.observe(doc.documentElement, { childList: true, subtree: true });
      }
      attach();
      if (win.customElements && typeof win.customElements.whenDefined === "function") {
        win.customElements.whenDefined("shopify-forms-embed").then(attach, function () {});
      }
    }

    function onPageShow(event) {
      if (event.persisted) start();
    }

    const handle = Object.freeze({
      disconnect: function () {
        destroyed = true;
        pause();
        win.removeEventListener("pagehide", pause);
        win.removeEventListener("pageshow", onPageShow);
        doc.removeEventListener("DOMContentLoaded", start);
      },
      getStatus: function () {
        return destroyed ? "disconnected" : binding ? "observing" : "waiting";
      }
    });

    win[INSTALL_KEY] = handle;
    win.addEventListener("pagehide", pause);
    win.addEventListener("pageshow", onPageShow);
    if (doc.readyState === "loading") {
      doc.addEventListener("DOMContentLoaded", start, { once: true });
    } else {
      start();
    }
    return handle;
  }

  return Object.freeze({
    createController: createController,
    install: install,
    isTargetPage: isTargetPage,
    privacyAllowed: privacyAllowed,
    sendExistingTag: sendExistingTag,
    constants: Object.freeze({ FORM_ID: FORM_ID, PAGE_PATH: PAGE_PATH,
      EVENT_NAME: EVENT_NAME, DESTINATION: DESTINATION, INSTALL_KEY: INSTALL_KEY,
      MAX_PENDING_MS: MAX_PENDING_MS })
  });
});
}

  } catch(e) { console.error(e); }
})();
})();
